const { pageName } = window.inlineGlobalConfig;

export function dlTrackVirtualPage(virtualPage, extendData = {}) {
  window.dataLayer.push({
    event: 'virtual page view',
    page_name: `/ga-virtual${pageName}/${virtualPage}`,
    ...extendData,
  });
}
